interface IProps {
  haszendeskchat: boolean;
  zendeskchat: string | number;
}

export const register = (props: IProps) => {
  if (!props.haszendeskchat) {
    return;
  }

  const script = document.createElement('script');
  script.id = 'ze-snippet';
  script.src = `https://static.zdassets.com/ekr/snippet.js?key=${props.zendeskchat}`;
  script.type = 'text/javascript';
  script.async = true;
  return script;
};
export const unregister = (props: IProps) => {
  if (!props.haszendeskchat) {
    return;
  }

  const launcher = document.getElementById('launcher');
  launcher?.parentNode.removeChild(launcher);
  const widget = document.querySelector('[data-product="web_widget"]');
  widget?.parentNode.removeChild(widget);

  document.getElementById('ze-snippet')?.remove();
  document.querySelectorAll('iframe').forEach(iframe => {
    if (iframe?.getAttribute('title') === 'Button to launch messaging window') {
      iframe.remove();
    }
  });
};
